import axios from "../api/axios"

export interface EntrepriseTeam {
  id?: number;
  entrepriseUserId: number;
  nom: string;
  prenom: string;
  email: string;
  rib: string;
  civility: string;
  solde?: number;
  sharedPercentageReferral?: number;
}

// Obtenir tous les membres
export const getAllEntrepriseTeams = async () => {
  const response = await axios.get(`enterprise-team/`);
  return response.data;
};

// Obtenir un membre par ID
export const getEntrepriseTeamById = async (id: number ) => {
  const response = await axios.get(`enterprise-team/${id}`);
  return response.data;
};
// Obtenir un membre par ID
export const getEntrepriseTeamByParentId = async (parentId: number ) => {
  const response = await axios.get(`enterprise-team/parent-id/${parentId}`);
  return response.data;
};

// Créer un membre
export const createEntrepriseTeam = async (data: EntrepriseTeam ) => {
  const response = await axios.post(`enterprise-team/`, { ...data, entrepriseUserId: localStorage.getItem('userId')});
  return response.data;
};

// Mettre à jour un membre
export const updateEntrepriseTeam = async (id: number, data: Partial<EntrepriseTeam> ) => {
  const response = await axios.put(`enterprise-team/${id}`, data);
  return response.data;
};

// Supprimer un membre
export const deleteEntrepriseTeam = async (id: number ) => {
  const response = await axios.delete(`enterprise-team/${id}`);
  return response.data;
};
